import { BoxV2 as Box, Flex, Grid } from 'portal-commons';
import { FunctionComponent } from 'react';

interface FormSectionProps {
  title?: string;
  description?: string;
}

const FormSection: FunctionComponent<FormSectionProps> = ({
  title,
  description,
  children,
}) => (
  <Flex
    sx={{
      flexDirection: 'column',
      gap: 'xxl',
      width: '100%',
      pb: 'xxl',
      borderBottomWidth: '1px',
      borderBottomStyle: 'solid',
      borderBottomColor: 't.black20',
    }}
  >
    {(title || description) && (
      <Flex
        sx={{
          flexDirection: 'column',
          gap: 'xs',
          width: '100%',
          pb: 'xs',
          borderBottomWidth: '1px',
          borderBottomStyle: 'solid',
          borderBottomColor: 't.black20',
          color: 't.black70',
          fontWeight: 400,
          fontSize: 'H300',
          lineHeight: 'normal',
          whiteSpace: 'pre-line',
        }}
      >
        {title && (
          <Flex
            sx={{
              alignItems: 'center',
              height: '32px',
              fontWeight: 600,
              fontSize: 'H500',
            }}
          >
            {title}
          </Flex>
        )}
        {description && <Box>{description}</Box>}
      </Flex>
    )}
    <Grid
      sx={{
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        columnGap: 'xl',
        rowGap: 'xxl',
      }}
    >
      {children}
    </Grid>
  </Flex>
);

export default FormSection;
